import { render } from "./TextMessageForm.vue?vue&type=template&id=df89e426"
import script from "./TextMessageForm.vue?vue&type=script&lang=ts"
export * from "./TextMessageForm.vue?vue&type=script&lang=ts"

import "./TextMessageForm.vue?vue&type=style&index=0&id=df89e426&lang=scss"
script.render = render

export default script